const t = {
  "@ado/base-application": {
    footer: {
      "terms-of-use": (e) => {
        const { normalize: r } = e;
        return r(["Conditions g\xE9n\xE9rales"]);
      },
      disclaimer: (e) => {
        const { normalize: r } = e;
        return r(["Mise en garde"]);
      },
      "about-us": (e) => {
        const { normalize: r } = e;
        return r(["\xC0 propos"]);
      },
      "cookie-policy": (e) => {
        const { normalize: r } = e;
        return r(["Cookies"]);
      },
      "privacy-policy": (e) => {
        const { normalize: r } = e;
        return r(["Donn\xE9es personnelles"]);
      },
      "google-privacy-policy": (e) => {
        const { normalize: r } = e;
        return r(["r\xE8gles de confidentialit\xE9"]);
      },
      "editorial-policy": (e) => {
        const { normalize: r } = e;
        return r(["Politique \xE9ditoriale"]);
      },
      consent: (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r([n(o("siteBrand")), " n\u2019est pas un cabinet d\u2019avocats et ne fournit pas de conseils juridiques. Nous fournissons des informations et des logiciels, et vous \xEAtes responsable de l'utilisation ad\xE9quate de ces ressources. ", n(o("copyRight"))]);
      },
      "terms-of-service": (e) => {
        const { normalize: r } = e;
        return r(["Conditions g\xE9n\xE9rales"]);
      },
      "use-of-site": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Votre utilisation de ce site est soumise \xE0 nos ", n(o("tos")), ", ", n(o("disclaimer")), ", ", n(o("cookiePolicy")), " ", n(o("privacyPolicy")), " et ", n(o("editorialPolicy")), "."]);
      },
      "recaptcha-google": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Ce site est prot\xE9g\xE9 par reCAPTCHA. Les ", n(o("googlePrivacyPolicy")), " et ", n(o("googleTos")), " appliquer."]);
      },
      "all-rights-reserved": (e) => {
        const { normalize: r } = e;
        return r(["Tous droits r\xE9serv\xE9s"]);
      },
      "terms-of-use-title": (e) => {
        const { normalize: r } = e;
        return r(["Conditions g\xE9n\xE9rales"]);
      },
      "disclaimer-title": (e) => {
        const { normalize: r } = e;
        return r(["Mise en garde"]);
      },
      "privacy-policy-title": (e) => {
        const { normalize: r } = e;
        return r(["Donn\xE9es personnelles"]);
      },
      "editorial-policy-title": (e) => {
        const { normalize: r } = e;
        return r(["Politique \xE9ditoriale"]);
      }
    },
    "footer-links": {
      about: (e) => {
        const { normalize: r } = e;
        return r(["\xC0 propos"]);
      },
      "affilicate-program": (e) => {
        const { normalize: r } = e;
        return r(["Programme d'Affili\xE9"]);
      },
      blog: (e) => {
        const { normalize: r } = e;
        return r(["Blog"]);
      },
      "business-solutions": (e) => {
        const { normalize: r } = e;
        return r(["Solutions d'affaires"]);
      },
      "cancel-page": (e) => {
        const { normalize: r } = e;
        return r([]);
      },
      careers: (e) => {
        const { normalize: r } = e;
        return r(["Carri\xE8res"]);
      },
      contact: (e) => {
        const { normalize: r } = e;
        return r(["Nous contacter"]);
      },
      home: (e) => {
        const { normalize: r } = e;
        return r(["Accueil"]);
      },
      "law-library": (e) => {
        const { normalize: r } = e;
        return r(["Biblioth\xE8que"]);
      },
      "legal-documents": (e) => {
        const { normalize: r } = e;
        return r(["Nos documents"]);
      },
      "legal-notice": (e) => {
        const { normalize: r } = e;
        return r(["Mentions l\xE9gales"]);
      },
      resources: (e) => {
        const { normalize: r } = e;
        return r(["Ressources"]);
      },
      "white-label-program": (e) => {
        const { normalize: r } = e;
        return r(["Service de marque blanche"]);
      }
    },
    "footer-policy-dialog": {
      "print-document": (e) => {
        const { normalize: r } = e;
        return r(["Imprimer le document"]);
      },
      "save-document": (e) => {
        const { normalize: r } = e;
        return r(["Enregistrer le document"]);
      }
    },
    help: (e) => {
      const { normalize: r } = e;
      return r(["Aide"]);
    },
    more: (e) => {
      const { normalize: r } = e;
      return r(["Autres pays"]);
    },
    or: (e) => {
      const { normalize: r } = e;
      return r(["ou"]);
    },
    "help-center": (e) => {
      const { normalize: r } = e;
      return r(["Centre d'aide"]);
    },
    countries: {
      "United States": (e) => {
        const { normalize: r } = e;
        return r(["\xC9tats-Unis"]);
      },
      Australia: (e) => {
        const { normalize: r } = e;
        return r(["Australie"]);
      },
      Austria: (e) => {
        const { normalize: r } = e;
        return r(["Autriche"]);
      },
      Canada: (e) => {
        const { normalize: r } = e;
        return r(["Canada"]);
      },
      "United Kingdom": (e) => {
        const { normalize: r } = e;
        return r(["Royaume-Uni"]);
      },
      Deutschland: (e) => {
        const { normalize: r } = e;
        return r(["Allemagne"]);
      },
      France: (e) => {
        const { normalize: r } = e;
        return r(["France"]);
      },
      India: (e) => {
        const { normalize: r } = e;
        return r(["Inde"]);
      },
      Ireland: (e) => {
        const { normalize: r } = e;
        return r(["Irlande"]);
      },
      Mexico: (e) => {
        const { normalize: r } = e;
        return r(["Mexico"]);
      },
      "New Zealand": (e) => {
        const { normalize: r } = e;
        return r(["Nouvelle-Z\xE9lande"]);
      },
      Nigeria: (e) => {
        const { normalize: r } = e;
        return r(["Nig\xE9ria"]);
      },
      Singapore: (e) => {
        const { normalize: r } = e;
        return r(["Singapour"]);
      },
      Spain: (e) => {
        const { normalize: r } = e;
        return r(["Spain"]);
      }
    },
    header: {
      "chat-online": (e) => {
        const { normalize: r } = e;
        return r(["Dialogue en Direct"]);
      },
      "email-us": (e) => {
        const { normalize: r } = e;
        return r(["Envoyez-nous un courriel"]);
      },
      "create-free-account": (e) => {
        const { normalize: r } = e;
        return r(["Cr\xE9er un compte gratuit"]);
      },
      "sign-in": (e) => {
        const { normalize: r } = e;
        return r(["Acc\xE9der \xE0 votre compte"]);
      },
      "search-this-site": (e) => {
        const { normalize: r } = e;
        return r(["Rechercher ce site..."]);
      },
      go: (e) => {
        const { normalize: r } = e;
        return r(["RECHERCHER"]);
      },
      "my-documents": (e) => {
        const { normalize: r } = e;
        return r(["Mes documents"]);
      },
      "my-account": (e) => {
        const { normalize: r } = e;
        return r(["Mon compte"]);
      },
      "sign-out": (e) => {
        const { normalize: r } = e;
        return r(["Se d\xE9connecter"]);
      },
      "upgrade-account": (e) => {
        const { normalize: r } = e;
        return r(["Mise \xE0 niveau du compte"]);
      },
      All: (e) => {
        const { normalize: r } = e;
        return r(["Tous les"]);
      },
      "all-documents": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Tous les documents de ", n(o("siteBrand"))]);
      }
    },
    "sign-in": {
      "already-have-account": (e) => {
        const { normalize: r } = e;
        return r(["Vous avez d\xE9j\xE0 un compte?"]);
      },
      "create-account-disclaimer": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Toutes les informations que vous fournissez sont strictement confidentielles et ne seront partag\xE9es avec aucune autre personne. Pour plus d'informations, veuillez consulter les liens suivants : ", n(o("privacyPolicy")), ", ", n(o("tos")), ", et ", n(o("emailPolicy")), "."]);
      },
      "create-an-account": (e) => {
        const { normalize: r } = e;
        return r(["Cr\xE9er un compte gratuit"]);
      },
      "create-new-account": (e) => {
        const { normalize: r } = e;
        return r(["Cr\xE9er un nouveau compte"]);
      },
      "create-password": (e) => {
        const { normalize: r } = e;
        return r(["Saisir votre mot de passe"]);
      },
      "check-email": (e) => {
        const { normalize: r } = e;
        return r(["Veuillez v\xE9rifier vos emails maintenant"]);
      },
      "common-error-message": (e) => {
        const { normalize: r } = e;
        return r(["Une erreur s\u2019est produite. Veuillez recharger la page et essayez \xE0 nouveau."]);
      },
      "invalid-password-message": (e) => {
        const { normalize: r } = e;
        return r(["Veuillez indiquer une mot de passe valide"]);
      },
      "invalid-email-message": (e) => {
        const { normalize: r } = e;
        return r(["Veuillez indiquer une adresse email valide"]);
      },
      "reset-password-success-first-message": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Nous enverrons un email \xE0 ", n(o("email")), " avec des instructions pour r\xE9initialiser le mot de passe."]);
      },
      "reset-password-success-second-message": (e) => {
        const { normalize: r } = e;
        return r(["Ouvrez-vous l\u2019email et cliquez sur le lien pour continuer."]);
      },
      "error-alert-title": (e) => {
        const { normalize: r } = e;
        return r(["Erreur"]);
      },
      "success-alert-title": (e) => {
        const { normalize: r } = e;
        return r(["Succ\xE8s !"]);
      },
      dialog: {
        "creating-account": (e) => {
          const { normalize: r } = e;
          return r(["Cr\xE9ation de compte en cours"]);
        },
        "signing-in": (e) => {
          const { normalize: r } = e;
          return r(["Connexion en cours"]);
        },
        "recovery-email": (e) => {
          const { normalize: r } = e;
          return r(["Email de r\xE9cup\xE9ration en cours d'envoi"]);
        },
        "answer-saved-header_male": (e) => {
          const { normalize: r, interpolate: n, named: o } = e;
          return r(["Votre ", n(o("productName")), " est enregistr\xE9"]);
        },
        "answer-saved-header_female": (e) => {
          const { normalize: r, interpolate: n, named: o } = e;
          return r(["Votre ", n(o("productName")), " est enregistr\xE9"]);
        },
        "signed-in": {
          "answer-saved-message_male": (e) => {
            const { normalize: r, interpolate: n, named: o } = e;
            return r(["Votre ", n(o("productName")), " a \xE9t\xE9 enregistr\xE9 dans votre compte ", n(o("siteBrand")), "."]);
          },
          "answer-saved-message_female": (e) => {
            const { normalize: r, interpolate: n, named: o } = e;
            return r(["Votre ", n(o("productName")), " a \xE9t\xE9 enregistr\xE9 dans votre compte ", n(o("siteBrand")), "."]);
          }
        },
        "create-account": {
          "answer-saved-message": (e) => {
            const { normalize: r, interpolate: n, named: o } = e;
            return r(["Vous avez cr\xE9\xE9 un compte avec ", n(o("siteBrand")), ". Nous vous enverrons un email de confirmation bient\xF4t."]);
          }
        },
        "answer-saved-message1_male": (e) => {
          const { normalize: r, interpolate: n, named: o } = e;
          return r(["Vous pouvez retourner et finir votre ", n(o("productName")), " quand vous le souhaitez."]);
        },
        "answer-saved-message1_female": (e) => {
          const { normalize: r, interpolate: n, named: o } = e;
          return r(["Vous pouvez retourner et finir votre ", n(o("productName")), " quand vous le souhaitez."]);
        }
      },
      email: (e) => {
        const { normalize: r } = e;
        return r(["Votre adresse email"]);
      },
      "email-policy": (e) => {
        const { normalize: r } = e;
        return r(["Politique de messagerie"]);
      },
      "forgot-password": (e) => {
        const { normalize: r } = e;
        return r(["J'ai oubli\xE9 mon mot de passe"]);
      },
      "if-you-prefer": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Si vous pr\xE9f\xE9rez, vous pouvez ", n(o("create")), " ou ", n(o("return")), "."]);
      },
      "no-account-text": (e) => {
        const { normalize: r } = e;
        return r(["Vous n'avez pas de compte?"]);
      },
      "no-thanks": (e) => {
        const { normalize: r } = e;
        return r(["Non merci"]);
      },
      password: (e) => {
        const { normalize: r } = e;
        return r(["Mot de passe"]);
      },
      "password-email-sent": (e) => {
        const { normalize: r } = e;
        return r(["Un email concernant votre mot de passe a \xE9t\xE9 envoy\xE9"]);
      },
      "password-reset": (e) => {
        const { normalize: r } = e;
        return r(["R\xE9initialisation de votre mot de passe"]);
      },
      "password-reset-instructions": (e) => {
        const { normalize: r } = e;
        return r(["Nous vous enverrons un email avec des instructions pour r\xE9initialiser votre mot de passe."]);
      },
      "return-sign-in": (e) => {
        const { normalize: r } = e;
        return r(["Acc\xE9der \xE0 votre compte"]);
      },
      "sign-in": (e) => {
        const { normalize: r } = e;
        return r(["Acc\xE9der \xE0 votre compte"]);
      },
      "sign-in-text": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Acc\xE9der \xE0 votre compte ", n(o("SiteBrand"))]);
      },
      "save-document": (e) => {
        const { normalize: r } = e;
        return r(["Sauvegarder mon document"]);
      },
      "save-product-create-text": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Enregistrez votre ", n(o("productName")), " avec un compte gratuit"]);
      },
      "save-product-login-text": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Se connecter pour sauvegarder votre ", n(o("productName"))]);
      }
    },
    "redirect-prompt": {
      "your-country-is-set-to": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Le pays s\xE9lectionn\xE9 est ", n(o("countryName"))]);
      },
      "change-to": (e) => {
        const { normalize: r, interpolate: n, named: o } = e;
        return r(["Changer : ", n(o("countryName"))]);
      },
      "dont-change": (e) => {
        const { normalize: r } = e;
        return r(["Ne pas changer"]);
      }
    }
  }
};
export {
  t as default
};
//# sourceMappingURL=index.js.map
